import Cancel from './modals/Cancel'
import Create from './modals/Create'
import Delete from './modals/Delete'
import Edit from './modals/Edit'
import Error from './modals/Error'
import ErrorDetails from './modals/ErrorDetails'
import Success from './modals/Success'
import HideSmallGroup from './modals/HideSmallGroup'
import AddInstructor from './modals/AddInstructor'
import LeaveClass from './modals/LeaveClass'
import Loading from './modals/Loading'
import ModalRouter from './modalRouter'
import { createInstanceContainer, mapper } from './containerFactory'

export {
  Cancel,
  Create,
  Delete,
  Edit,
  Error,
  ErrorDetails,
  Success,
  HideSmallGroup,
  AddInstructor,
  LeaveClass,
  Loading,
  ModalRouter,
  createInstanceContainer,
  mapper,
}
